var _defs, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#47d5cd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M104.33,41.36c-.15,0-.31,.01-.46,.04-3.1,.49-6.18,.73-9.15,.73s-5.89-.24-8.72-.73c-4.03-.69-5.77-1.64-7.78-2.74-2.17-1.19-4.62-2.53-9.63-3.43-3.19-.57-6.33-.86-9.33-.86s-5.8,.28-8.55,.83c-.38-1.83-2-3.2-3.94-3.2h-.09c-2.22,0-4.02,1.8-4.02,4.02V113.98c0,2.22,1.8,4.02,4.02,4.02h.09c2.22,0,4.02-1.8,4.02-4.02v-33.7c.09,0,.17,.02,.26,.02,.16,0,.32-.01,.49-.04,2.84-.47,5.66-.7,8.37-.7s5.37,.23,7.94,.69c3.55,.64,5.26,1.57,7.24,2.66,2.27,1.24,4.84,2.65,9.94,3.52,3.15,.54,6.41,.81,9.7,.81s6.66-.27,10.08-.81c1.46-.23,2.53-1.49,2.53-2.96V44.36c0-.88-.38-1.71-1.05-2.28-.55-.47-1.24-.72-1.95-.72ZM47.8,113.98c0,.56-.46,1.02-1.02,1.02h-.09c-.56,0-1.02-.46-1.02-1.02V36.02c0-.56,.46-1.02,1.02-1.02h.09c.56,0,1.02,.46,1.02,1.02V113.98Zm56.53-30.5c-3.27,.51-6.48,.77-9.61,.77s-6.2-.26-9.19-.77c-8.98-1.54-8.88-4.69-17.15-6.18-2.76-.49-5.58-.74-8.47-.74s-5.84,.25-8.86,.74V38.19c2.64-.54,5.37-.82,8.2-.82s5.77,.27,8.8,.82c9.09,1.63,8.42,4.64,17.44,6.18,3.01,.51,6.08,.77,9.22,.77s6.34-.26,9.61-.77v39.12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M76.21,56.43c0-1.35,.76-1.87,2.19-1.87,1.25,0,2.22,.51,3.33,1.52l2.38-2.76c-1.19-1.3-2.63-2.25-4.6-2.55v-3.14h-3.17v3.2c-2.95,.6-4.71,2.74-4.71,5.82,0,5.53,8.1,5.61,8.1,8.56,0,1.33-.73,1.98-2.41,1.98-1.41,0-2.76-.57-4.36-1.79l-2.11,3.25c1.49,1.35,3.68,2.17,5.5,2.38v3.06h3.17v-3.22c3.22-.7,4.82-3.03,4.82-6.01,0-5.82-8.12-5.69-8.12-8.42Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMission);
export default __webpack_public_path__ + "static/media/mission.5a4cd0c5ecf15d49e442f24e340415c7.svg";
export { ForwardRef as ReactComponent };